import { NgModule } from '@angular/core';
import { RouteWrapperComponent } from './components/route-wrapper/route-wrapper.component';
import { DialogWrapperComponent } from './components/dialog-wrapper/dialog-wrapper.component';
import { WrapperComponent } from './components/wrapper/wrapper.component';

@NgModule({
	declarations: [WrapperComponent, DialogWrapperComponent, RouteWrapperComponent],
	imports: [],
	providers: [],
	exports: [RouteWrapperComponent],
})
export class WrapperModule {}

export * from './components/wrapper/wrapper.component';
export * from './components/dialog-wrapper/dialog-wrapper.component';
export * from './components/route-wrapper/route-wrapper.component';
export * from './components/wrappable/wrappable.component';
export * from './types/IWrappableComponent';
